import ManageLocation from "./ManageLocation";

export default ManageLocation;
